import React, { Component } from 'react';
import axios from "axios/dist/axios.min.js";
import utils from "../../utils/utils";
import "./style.less";

class PipelineRecommend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goodsList: []
    };
  }

  componentDidMount(){
    this.getProductListData();
  }

  getProductListData = () => {
    const itemList = this.props.config.itemList;
    const idList = itemList.map((item) => {
      return isNaN(Number(item.id)) ? 0 : Number(item.id);
    });

    let reqUrl = "";
    if (this.props.config.baseConfig.productType === "商品id") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";
    } else {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";
    }

    axios({
      url: reqUrl,
      method: "post",
      withCredentials: true,
      data: {
        ids: idList,
        sort_tag: this.props.config.baseConfig.sortType === '销量' ? 4 : 0,
        filter_subsidy: this.props.config.baseConfig.shihuoSubsidy === '是' ? 1 : 0,
        from: this.props.specialApiFrom
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const list = res.data.data.List;
        // 插入定制化内容
        list.forEach((product) => {
          const customItem = itemList.find((item) => item.id == product.id);
          if (customItem) {
            product.custom_title = customItem.name;
            product.custom_recommend = customItem.recommend;
          }
        });
        this.setState({
          goodsList: list
        })
      }
    });
  }
 
  // 图片跳转
  productBannerGo = (url) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: url,
        props: this.props,
      })
      return
    }

    const options = { title: 3 };
    const convertUrl = utils.convertHref(url);
    utils.jumpToUrl(this.props.routeParams,convertUrl,url,options,-1,this.props,false);
  }

  // 商品跳转
  handleItemClick = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.url,
        props: this.props,
        index
      })
      return
    }

    const baseConfig = this.props.config.baseConfig;
    const options = {
      title: baseConfig.title,
      title: 3,
      sort: index,
      name: item.title
    };
    if (baseConfig.productType === "商品id") {
      options.goods_id = item.id;
    } else {
      options.style_id = item.id;
    }
    utils.jumpToUrl(this.props.routeParams,item.url,item.url,options,item.id,this.props);
  }

  render(){
    const { baseConfig } = this.props.config;
    const { goodsList } = this.state;
    const { componentDivideLine } = this.props
    return (
      <div 
        className="pipeline-recommend"
        style={{
          backgroundColor: baseConfig.bgColor,
        }}
        {...this.props['customAttributes']}
      >
        <div className="title-img">
          <img src={utils.formatImgUrl(this.props.config.baseConfig.titleImage, this.props.webpSupport)} onClick={this.productBannerGo.bind(this, this.props.config.baseConfig.titleLink)} />
        </div>
        <div className="goods-body">
          <div className="goods-scroll">
            {
              goodsList.map((item, index) => {
                return (
                  <div className="goods-item" key={`goods-${index}`} onClick={this.handleItemClick.bind(this, item, index)}>
                    <div className="goods-item-title">{item.title}</div>
                    <div className="goods-item-desc">{item.recommend}</div>
                    <div className="goods-item-img">
                      <img src={utils.formatImgUrl(item.image, this.props.webpSupport)} alt="" />
                    </div>
                    <div className="goods-item-bottom">
                      <div className="goods-item-originalprice">
                        <span style={{ opacity : (+item.original_price > 0 && +item.original_price > +item.price) ? 1 : 0 }}>¥{item.original_price}</span>
                        <span>到手价:</span>
                      </div>
                      <div style={{ color: baseConfig.priceTxtColor}} className="goods-item-price">
                        <span>¥</span>
                        <span>{item.price}</span>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
        {this.props.notLastItem && componentDivideLine &&  (
          <img className="component-divide-line" src={utils.formatImgUrl(componentDivideLine, this.props.webpSupport)} src={componentDivideLine} />
        )}
      </div>
    );
  }
}

export default PipelineRecommend;



// WEBPACK FOOTER //
// ./components/pipeline-recommend/index.jsx